import {
  GET_ACTIVITY,
  GET_ACTIVITY_SUCCESS,
  GET_ACTIVITY_ERROR,
  DELETE_ACTIVITY,
  DELETE_ACTIVITY_SUCCESS,
  DELETE_ACTIVITY_ERROR
} from "../actions";

export const getActivity = (activityId, activityInfo) => ({
    type: GET_ACTIVITY,
    payload: { activityId, activityInfo},
  });

export const getActivitySuccess = (activity) => ({
  type: GET_ACTIVITY_SUCCESS,
  payload: activity,
});

export const getActivityError = (message) => ({
  type: GET_ACTIVITY_ERROR,
  payload: { message },
});

export const trashActivity = (activityId) => ({
  type: DELETE_ACTIVITY,
  payload: { activityId },
});

export const trashActivitySuccess = (successMessage) => ({
  type: DELETE_ACTIVITY_SUCCESS,
  payload: { successMessage },
});

export const trashActivityError = (message) => ({
  type: DELETE_ACTIVITY_ERROR,
  payload: { message },
});
